import React from "react";
import { FaArrowLeft, FaCalendarAlt, FaMapMarkerAlt, FaShareAltSquare } from "react-icons/fa";

function SharedEventsHero({
  totalEvents = 0,
  upcomingEvents = 0,
  departmentsCount = 0,
  onBack,
}) {
  return (
    <header className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0">
        <img
          src="/img/cover/cover_calendar_france.jpeg"
          alt="Événements partagés"
          className="h-full w-full object-cover opacity-75"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/80 to-blue-950/80" />
      </div>

      <div className="relative mx-auto flex min-h-[360px] w-full max-w-[1280px] flex-col justify-end px-4 pb-20 pt-12 sm:px-6 lg:px-8">
        <button
          type="button"
          onClick={onBack}
          className="mb-8 inline-flex w-fit min-h-11 items-center justify-center gap-2 rounded-2xl bg-white/10 px-4 py-2 text-sm font-bold text-white backdrop-blur-xl transition hover:-translate-y-0.5 hover:bg-white/20"
        >
          <FaArrowLeft />
          Retour accueil
        </button>

        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
            <FaShareAltSquare />
            Judo Coach Pro
          </div>

          <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Trouver un événement partagé
          </h1>

          <p className="mt-5 max-w-2xl text-base font-medium leading-8 text-white/75 sm:text-lg">
            Une vue claire et mobile-first pour repérer les événements utiles,
            consulter les détails et les ajouter à son agenda judoka.
          </p>
        </div>

        <div className="mt-8 grid max-w-3xl gap-3 sm:grid-cols-3">
          <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
            <FaCalendarAlt className="text-sky-200" />
            <p className="mt-3 text-2xl font-bold">{totalEvents}</p>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
              Partagés
            </p>
          </div>

          <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
            <FaCalendarAlt className="text-emerald-200" />
            <p className="mt-3 text-2xl font-bold">{upcomingEvents}</p>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
              À venir
            </p>
          </div>

          <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
            <FaMapMarkerAlt className="text-orange-200" />
            <p className="mt-3 text-2xl font-bold">{departmentsCount}</p>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
              Départements
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default SharedEventsHero;